"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IBboxesRelativeInternal = exports.bboxHistoryInit = exports.defaultValue = exports.IBboxesRelative = void 0;
var utils_1 = require("../../../utils");
exports.IBboxesRelative = (0, utils_1.IRecord)({
    lastOp: '',
    list: (0, utils_1.IList)()
});
exports.defaultValue = (0, utils_1.IMap)([]);
exports.bboxHistoryInit = (0, utils_1.IList)([exports.defaultValue]);
exports.IBboxesRelativeInternal = (0, utils_1.IRecord)({
    lastOp: '',
    historyIdx: 0,
    history: exports.bboxHistoryInit
});
